import { render } from "./CultureView.vue?vue&type=template&id=42f5f4a3&scoped=true&ts=true"
import script from "./CultureView.vue?vue&type=script&lang=ts"
export * from "./CultureView.vue?vue&type=script&lang=ts"

import "./CultureView.vue?vue&type=style&index=0&id=42f5f4a3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f5f4a3"]])

export default __exports__